<template>
  <div>
    <div class="quit" id="quit">
      <button @click="Logout">退出登录</button>
    </div>
    <div class="box">
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types'
export default {
  name: 'MeQuit',
  methods: {
    Logout () {
      this.$store.commit(types.LOGOUT)
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style scoped>
.quit{ margin-top: 28px;}
.quit button{ width: 80%; margin-right: auto; margin-left: auto; background-color: #ed2727; color: #fff; display: block; border: 0; height: 33px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
.box{ height: 80px;}
</style>



// WEBPACK FOOTER //
// src/pages/me/components/Quit.vue